/**
 * Thunderbird compose paragraph styles = Gecko `html.css` (EditorOverride.css is empty).
 * Used in the Slate composer and the message iframe so spacing matches Thunderbird.
 */
import type { CSSProperties } from 'react';

export const THUNDERBIRD_BODY_TEXT_STYLE: CSSProperties = {
  margin: 0,
  minHeight: '1.2em',
};

export const THUNDERBIRD_PARAGRAPH_STYLE: CSSProperties = {
  margin: '1em 0',
};

export const THUNDERBIRD_HEADING_STYLES: Record<
  'heading-one' | 'heading-two' | 'heading-three' | 'heading-four' | 'heading-five' | 'heading-six',
  CSSProperties
> = {
  'heading-one': { fontSize: '2em', fontWeight: 'bold', margin: '0.67em 0' },
  'heading-two': { fontSize: '1.5em', fontWeight: 'bold', margin: '0.83em 0' },
  'heading-three': { fontSize: '1.17em', fontWeight: 'bold', margin: '1em 0' },
  'heading-four': { fontSize: '1em', fontWeight: 'bold', margin: '1.33em 0' },
  'heading-five': { fontSize: '0.83em', fontWeight: 'bold', margin: '1.67em 0' },
  'heading-six': { fontSize: '0.67em', fontWeight: 'bold', margin: '2.33em 0' },
};

export const THUNDERBIRD_ADDRESS_STYLE: CSSProperties = {
  fontStyle: 'italic',
  margin: 0,
};

/** Thunderbird `<pre>` uses `white-space: pre`; we wrap so long lines stay on screen. */
export const THUNDERBIRD_PREFORMAT_STYLE: CSSProperties = {
  whiteSpace: 'pre-wrap',
  fontFamily: 'monospace',
  margin: '1em 0',
};

/** Injected into the read-message iframe (no Tailwind reset there). */
export const THUNDERBIRD_VIEWER_BLOCK_CSS =
  'body p{margin:1em 0}' +
  'body div{margin:0}' +
  'body h1{font-size:2em;font-weight:bold;margin:0.67em 0}' +
  'body h2{font-size:1.5em;font-weight:bold;margin:0.83em 0}' +
  'body h3{font-size:1.17em;font-weight:bold;margin:1em 0}' +
  'body h4{font-size:1em;font-weight:bold;margin:1.33em 0}' +
  'body h5{font-size:0.83em;font-weight:bold;margin:1.67em 0}' +
  'body h6{font-size:0.67em;font-weight:bold;margin:2.33em 0}' +
  'body address{font-style:italic;margin:0}' +
  'body pre{font-family:monospace;margin:1em 0}';
